import composeStore from '../store/composeStore';

/**
 * This is getting consumed from other packages (eg. in AttachmentWellView
 * it's used to decide the styles if we are in compose or reading pane)
 */
export default (): boolean => !!composeStore.defaultViewState;
